<template>
  <ProSpaceGeoLayout class="addressprogramorder" v-if="model">
    <template #top>
      <ProSpaceTopPanel :header="layoutName" back @back="backHandler">
        <template #center>
          <ProSpaceTag
            v-if="headerTag && Object.keys(headerTag).length && !this.isMultiAdjustmentMode"
            :text="headerTag.text"
            :type="headerTag.type"
            :prefix="headerTag.prefix"
            bordered
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout
        :is-templated="true"
        :template-center="true"
        :template-right="true"
      >
        <template #center>
          <ProSpaceTabs
            v-model="activeTab"
            :tabs="overviewTabs"
            :loading="loading"
            :refLoading="mixinLoadingAccess"
            @select-tab="onSelectTab"
          >
            <template v-slot:tab-1>
              <ProSpaceVLayout class="addressprogramorder__rows">
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.networkId.$error &&
                    !v$.model.address.$error &&
                    !v$.model.coverage.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramOutletInfo')"
                      :bottom="$t('addressProgramOutletDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceHLayout
                      justify-content="flex-start"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceSearchfield
                        ref="networkId-ProSpaceSearchfield"
                        v-model="model.networkId"
                        disabled
                        getMethod="grid"
                        optionValue="id"
                        optionLabel="value"
                        filterModel="value"
                        :displayValue="model.networkValue"
                        :label="$t('addressProgramOrderNetworkValue')"
                        :txtTitleModal="$t('addressProgramOrderNetworkValue')"
                        :searchPlaceholder="
                          adjustmentFields.includes('networkId')
                            ? $t('addressProgramOrderAdjustmentNewValue')
                            : $t('addressProgramOrderNetworkValue')
                        "
                        :applyTxt="$t('applyTxt')"
                        :cancelTxt="$t('cancelTxt')"
                        :service="networkService"
                        :columns="networkColumns"
                        :fastFilters="[]"
                        :defaultFilter="{ disabled: { and: [false] } }"
                        :invalid="v$.model.networkId.$error"
                        :invalid-messages="v$.model.networkId.$errors"
                        :grid-styles="searchFieldGridStyles"
                        @blur="v$.model.networkId.$touch"
                        @update:modelValue="
                          changeModelValue('networkValue', 'networkId')
                        "
                      />
                      <ProSpaceInputText
                        ref="address-ProSpaceInputText"
                        v-model="model.address"
                        disabled
                        :label="$t('addressProgramOrderAddress')"
                        :placeholder="
                          adjustmentFields.includes('address')
                            ? $t('addressProgramOrderAdjustmentNewValue')
                            : $t('addressProgramOrderAddress')
                        "
                        :invalid="v$.model.address.$error"
                        :invalid-messages="v$.model.address.$errors"
                        @blur="v$.model.address.$touch"
                      />
                      <ProSpaceDropdown ref="coverage-ProSpaceInputSwitch"
                        v-model="model.coverage"
                        :disabled="disabled"
                        :options="coverageOptions"
                        propLabel="label"
                        propValue="value"
                        :placeholder="$t('selectValue')"
                        :label="$t('coverage')"
                      />
                    </ProSpaceHLayout>
                  </template>
                  <template
                    v-if="
                      v$.model.networkId.$error ||
                      v$.model.address.$error ||
                      v$.model.coverage.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.area.$error &&
                    !v$.model.city.$error &&
                    !v$.model.clusterId.$error &&
                    !v$.model.rsmId.$error &&
                    !v$.model.tdmId.$error &&
                    !v$.model.kaeId.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramGeoPointInfo')"
                      :bottom="$t('addressProgramGeoPointDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceInputText
                          ref="area-ProSpaceInputText"
                          v-model="model.area"
                          disabled
                          :label="$t('addressProgramOrderArea')"
                          :placeholder="
                            adjustmentFields.includes('area')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderArea')
                          "
                          :invalid="v$.model.area.$error"
                          :invalid-messages="v$.model.area.$errors"
                          @blur="v$.model.area.$touch"
                        />
                        <ProSpaceInputText
                          ref="city-ProSpaceInputText"
                          v-model="model.city"
                          disabled
                          :label="$t('addressProgramOrderCity')"
                          :placeholder="
                            adjustmentFields.includes('city')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderCity')
                          "
                          :invalid="v$.model.city.$error"
                          :invalid-messages="v$.model.city.$errors"
                          @blur="v$.model.city.$touch"
                        />
                        <ProSpaceSearchfield
                          ref="clusterId-ProSpaceSearchfield"
                          v-model="model.clusterId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.clusterValue"
                          :label="$t('addressProgramOrderClusterValue')"
                          :txtTitleModal="$t('addressProgramOrderClusterValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('clusterId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderClusterValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="clusterService"
                          :columns="clusterColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.clusterId.$error"
                          :invalid-messages="v$.model.clusterId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.clusterId.$touch"
                          @update:modelValue="
                            changeModelValue('clusterValue', 'clusterId')
                          "
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceSearchfield
                          ref="rsmId-ProSpaceSearchfield"
                          v-model="model.rsmId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.rsmValue"
                          :label="$t('addressProgramOrderRSMValue')"
                          :txtTitleModal="$t('addressProgramOrderRSMValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('rsmId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderRSMValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="rSMService"
                          :columns="rSMColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.rsmId.$error"
                          :invalid-messages="v$.model.rsmId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.rsmId.$touch"
                          @update:modelValue="
                            changeModelValue('rsmValue', 'rsmId')
                          "
                        />
                        <ProSpaceSearchfield
                          ref="tdmId-ProSpaceSearchfield"
                          v-model="model.tdmId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.tdmValue"
                          :label="$t('addressProgramOrderTdmValue')"
                          :txtTitleModal="$t('addressProgramOrderTdmValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('tdmId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderTdmValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="tDMService"
                          :columns="tDMColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.tdmId.$error"
                          :invalid-messages="v$.model.tdmId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.tdmId.$touch"
                          @update:modelValue="
                            changeModelValue('tdmValue', 'tdmId')
                          "
                        />
                        <ProSpaceSearchfield
                          ref="kaeId-ProSpaceSearchfield"
                          v-model="model.kaeId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.kaeValue"
                          :label="$t('addressProgramOrderKaeValue')"
                          :txtTitleModal="$t('addressProgramOrderKaeValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('kaeId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderKaeValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="kAEService"
                          :columns="kAEColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.kaeId.$error"
                          :invalid-messages="v$.model.kaeId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.kaeId.$touch"
                          @update:modelValue="
                            changeModelValue('kaeValue', 'kaeId')
                          "
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>

                  <template
                    v-if="
                      v$.model.area.$error ||
                      v$.model.city.$error ||
                      v$.model.clusterId.$error ||
                      v$.model.rsmId.$error ||
                      v$.model.tdmId.$error ||
                      v$.model.kaeId.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.externalFormatId.$error &&
                    !v$.model.outletTypeId.$error &&
                    !v$.model.channelId.$error &&
                    !v$.model.narkaId.$error &&
                    !v$.model.sipChannelId.$error &&
                    !v$.model.territoryCluster.$error &&
                    !v$.model.externalCode.$error &&
                    !v$.model.tariffZone.$error &&
                    !v$.model.skyline.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramClassifiersParamsInfo')"
                      :bottom="$t('addressProgramClassifiersParamsDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceSearchfield
                          ref="externalFormatId-ProSpaceSearchfield"
                          v-model="model.externalFormatId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.externalFormatValue"
                          :label="$t('addressProgramOrderExternalFormatValue')"
                          :txtTitleModal="$t('addressProgramOrderExternalFormatValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('externalFormatId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderExternalFormatValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="externalFormatService"
                          :columns="externalFormatColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.externalFormatId.$error"
                          :invalid-messages="v$.model.externalFormatId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.externalFormatId.$touch"
                          @update:modelValue="
                            changeModelValue(
                              'externalFormatValue',
                              'externalFormatId'
                            )
                          "
                        />
                        <ProSpaceSearchfield
                          ref="outletTypeId-ProSpaceSearchfield"
                          v-model="model.outletTypeId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.outletTypeValue"
                          :label="$t('addressProgramOrderOutletTypeValue')"
                          :txtTitleModal="$t('addressProgramOrderOutletTypeValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('outletTypeId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderOutletTypeValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="outletTypeService"
                          :columns="outletTypeColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.outletTypeId.$error"
                          :invalid-messages="v$.model.outletTypeId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.outletTypeId.$touch"
                          @update:modelValue="
                            changeModelValue('outletTypeValue', 'outletTypeId')
                          "
                        />
                        <ProSpaceSearchfield
                          ref="channelId-ProSpaceSearchfield"
                          v-model="model.channelId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.channelValue"
                          :label="$t('addressProgramOrderChannelValue')"
                          :txtTitleModal="$t('addressProgramOrderChannelValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('channelId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderChannelValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="channelService"
                          :columns="channelColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.channelId.$error"
                          :invalid-messages="v$.model.channelId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.channelId.$touch"
                          @update:modelValue="
                            changeModelValue('channelValue', 'channelId')
                          "
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceSearchfield
                          ref="narkaId-ProSpaceSearchfield"
                          v-model="model.narkaId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.narkaValue"
                          :label="$t('addressProgramOrderNarkaValue')"
                          :txtTitleModal="$t('addressProgramOrderNarkaValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('narkaId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderNarkaValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="nARKAService"
                          :columns="nARKAColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.narkaId.$error"
                          :invalid-messages="v$.model.narkaId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.narkaId.$touch"
                          @update:modelValue="
                            changeModelValue('narkaValue', 'narkaId')
                          "
                        />
                        <ProSpaceSearchfield
                          ref="sipChannelId-ProSpaceSearchfield"
                          v-model="model.sipChannelId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.sipChannelValue"
                          :label="$t('addressProgramOrderSipChannelValue')"
                          :txtTitleModal="$t('addressProgramOrderSipChannelValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('sipChannelId')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderSipChannelValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="sIPChannelService"
                          :columns="sIPChannelColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.sipChannelId.$error"
                          :invalid-messages="v$.model.sipChannelId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.sipChannelId.$touch"
                          @update:modelValue="
                            changeModelValue('sipChannelValue', 'sipChannelId')
                          "
                        />
                        <ProSpaceInputNumber
                          ref="territoryCluster-ProSpaceInputNumber"
                          v-model="model.territoryCluster"
                          disabled
                          :label="$t('addressProgramOrderTerritoryCluster')"
                          :placeholder="
                            adjustmentFields.includes('territoryCluster')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderTerritoryCluster')
                          "
                          :invalid="v$.model.territoryCluster.$error"
                          :invalid-messages="v$.model.territoryCluster.$errors"
                          likeText
                          @blur="v$.model.territoryCluster.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                        style="display: grid; grid-template-columns: repeat(3, 1fr);"
                      >
                        <ProSpaceInputText
                          ref="externalCode-ProSpaceInputText"
                          v-model="model.externalCode"
                          disabled
                          :label="$t('addressProgramOrderExternalCode')"
                          :placeholder="
                            adjustmentFields.includes('externalCode')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderExternalCode')
                          "
                          :invalid="v$.model.externalCode.$error"
                          :invalid-messages="v$.model.externalCode.$errors"
                          likeText
                          @blur="v$.model.externalCode.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="tariffZone-ProSpaceInputNumber"
                          v-model="model.tariffZone"
                          disabled
                          :label="$t('addressProgramOrderTariffZone')"
                          :placeholder="
                            adjustmentFields.includes('tariffZone')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderTariffZone')
                          "
                          :invalid="v$.model.tariffZone.$error"
                          :invalid-messages="v$.model.tariffZone.$errors"
                          likeText
                          @blur="v$.model.tariffZone.$touch"
                        />
                        
                        <ProSpaceInputText
                          ref="skyline-ProSpaceInputNumber"
                          v-model="model.skyline"
                          disabled
                          :label="$t('addressProgramOrderSkyline')"
                          :placeholder="
                            adjustmentFields.includes('skyline')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderSkyline')
                          "
                          :invalid="v$.model.skyline.$error"
                          :invalid-messages="v$.model.skyline.$errors"
                          likeText
                          @blur="v$.model.skyline.$touch"
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>

                  <template
                    v-if="
                      v$.model.externalFormatId.$error ||
                      v$.model.outletTypeId.$error ||
                      v$.model.channelId.$error ||
                      v$.model.narkaId.$error ||
                      v$.model.sipChannelId.$error ||
                      v$.model.territoryCluster.$error ||
                      v$.model.externalCode.$error ||
                      v$.model.tariffZone.$error ||
                      v$.model.skyline.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.kasValue.$error &&
                    !v$.model.merchandiserValue.$error &&
                    !v$.model.routeCodeValue.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramAgencyParamsInfo')"
                      :bottom="$t('addressProgramAgencyParamsDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                        style="display: grid; grid-template-columns: repeat(3, 1fr);"
                      >
                        <ProSpaceSearchfield
                          v-if="!adjustmentMode"
                          ref="agencyId-ProSpaceSearchfield"
                          v-model="model.agencyId"
                          disabled
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.agencyValue"
                          :label="$t('addressProgramOrderAgencyValue')"
                          :txtTitleModal="$t('addressProgramOrderAgencyValue')"
                          :searchPlaceholder="
                            $t('addressProgramOrderAgencyValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="agencyService"
                          :columns="agencyColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.agencyId.$error"
                          :invalid-messages="v$.model.agencyId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.agencyId.$touch"
                          @update:modelValue="
                            changeModelValue('agencyValue', 'agencyId')
                          "
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceSearchfield
                          ref="kasValue-ProSpaceSearchfield"
                          v-model="model.kasValue"
                          disabled
                          getMethod="grid"
                          optionValue="value"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.kasValue"
                          :label="$t('addressProgramOrderKasValue')"
                          :txtTitleModal="$t('addressProgramOrderKasValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('kasValue')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderKasValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="kASService"
                          :columns="kASColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.kasValue.$error"
                          :invalid-messages="v$.model.kasValue.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.kasValue.$touch"
                        />
                        <ProSpaceSearchfield
                          ref="merchandiserValue-ProSpaceSearchfield"
                          v-model="model.merchandiserValue"
                          disabled
                          getMethod="grid"
                          optionValue="value"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.merchandiserValue"
                          :label="$t('addressProgramOrderMerchandiserValue')"
                          :txtTitleModal="$t('addressProgramOrderMerchandiserValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('merchandiserValue')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderMerchandiserValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="merchandiserService"
                          :columns="merchandiserColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.merchandiserValue.$error"
                          :invalid-messages="v$.model.merchandiserValue.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.merchandiserValue.$touch"
                        />
                        <ProSpaceSearchfield
                          ref="routeCodeValue-ProSpaceSearchfield"
                          v-model="model.routeCodeValue"
                          disabled
                          getMethod="grid"
                          optionValue="value"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.routeCodeValue"
                          :label="$t('addressProgramOrderRouteCodeValue')"
                          :txtTitleModal="$t('addressProgramOrderRouteCodeValue')"
                          :searchPlaceholder="
                            adjustmentFields.includes('routeCodeValue')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderRouteCodeValue')
                          "
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="routeCodeService"
                          :columns="routeCodeColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.routeCodeValue.$error"
                          :invalid-messages="v$.model.routeCodeValue.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.routeCodeValue.$touch"
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>

                  <template
                    v-if="
                      v$.model.kasValue.$error ||
                      v$.model.merchandiserValue.$error ||
                      v$.model.routeCodeValue.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.frequencyPlan.$error &&
                    !v$.model.timingPerVisitPlan.$error &&
                    !v$.model.fteMerchPlan.$error &&
                    !v$.model.osaPlan.$error &&
                    !v$.model.deltaISAOSAPlan.$error &&
                    !v$.model.pssPlan.$error &&
                    !v$.model.tacticalTaskPlan.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramKPIInfo')"
                      :bottom="$t('addressProgramKPIDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceInputNumber
                          ref="frequencyPlan-ProSpaceInputNumber"
                          v-model="model.frequencyPlan"
                          disabled
                          :integeronly="true"
                          :label="$t('addressProgramOrderFrequency')"
                          :placeholder="
                            adjustmentFields.includes('frequencyPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderFrequency')
                          "
                          :invalid="v$.model.frequencyPlan.$error"
                          :invalid-messages="v$.model.frequencyPlan.$errors"
                          likeText
                          @blur="v$.model.frequencyPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="timingPerVisitPlan-ProSpaceInputNumber"
                          v-model="model.timingPerVisitPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderTimingPerVisit')"
                          :placeholder="
                            adjustmentFields.includes('timingPerVisitPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderTimingPerVisit')
                          "
                          :invalid="v$.model.timingPerVisitPlan.$error"
                          :invalid-messages="
                            v$.model.timingPerVisitPlan.$errors
                          "
                          likeText
                          @blur="v$.model.timingPerVisitPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="fteMerchPlan-ProSpaceInputNumber"
                          v-model="model.fteMerchPlan"
                          disabled
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderFteMerch')"
                          :placeholder="$t('addressProgramOrderFteMerch')"
                          :invalid="v$.model.fteMerchPlan.$error"
                          :invalid-messages="v$.model.fteMerchPlan.$errors"
                          likeText
                          @blur="v$.model.fteMerchPlan.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceInputNumber
                          ref="osaPlan-ProSpaceInputNumber"
                          v-model="model.osaPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :min="0"
                          :max="100"
                          :label="`${$t('addressProgramOrderOsa')}, %`"
                          :placeholder="
                            adjustmentFields.includes('osaPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderOsa')
                          "
                          :invalid="v$.model.osaPlan.$error"
                          :invalid-messages="v$.model.osaPlan.$errors"
                          likeText
                          @blur="v$.model.osaPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="deltaISAOSAPlan-ProSpaceInputNumber"
                          v-model="model.deltaISAOSAPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :min="0"
                          :max="100"
                          :label="`${$t('addressProgramOrderDeltaISAOSA')}, %`"
                          :placeholder="
                            adjustmentFields.includes('deltaISAOSAPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderDeltaISAOSA')
                          "
                          :invalid="v$.model.deltaISAOSAPlan.$error"
                          :invalid-messages="v$.model.deltaISAOSAPlan.$errors"
                          likeText
                          @blur="v$.model.deltaISAOSAPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="pssPlan-ProSpaceInputNumber"
                          v-model="model.pssPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :min="0"
                          :max="100"
                          :label="`${$t('addressProgramOrderPss')}, %`"
                          :placeholder="
                            adjustmentFields.includes('pssPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderPss')
                          "
                          :invalid="v$.model.pssPlan.$error"
                          :invalid-messages="v$.model.pssPlan.$errors"
                          likeText
                          @blur="v$.model.pssPlan.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >

                        <ProSpaceInputNumber
                          ref="tacticalTaskPlan-ProSpaceInputNumber"
                          v-model="model.tacticalTaskPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderTacticalTask')"
                          :placeholder="
                            adjustmentFields.includes('tacticalTaskPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderTacticalTask')
                          "
                          :invalid="v$.model.tacticalTaskPlan.$error"
                          :invalid-messages="v$.model.tacticalTaskPlan.$errors"
                          likeText
                          @blur="v$.model.tacticalTaskPlan.$touch"
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>

                  <template
                    v-if="
                      v$.model.frequencyPlan.$error ||
                      v$.model.timingPerVisitPlan.$error ||
                      v$.model.fteMerchPlan.$error ||
                      v$.model.osaPlan.$error ||
                      v$.model.deltaISAOSAPlan.$error ||
                      v$.model.pssPlan.$error ||
                      v$.model.tacticalTaskPlan.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="
                    !v$.model.ratePerHourPlan.$error &&
                    !v$.model.visitSumPlan.$error &&
                    !v$.model.osaSumPlan.$error &&
                    !v$.model.pssSumPlan.$error &&
                    !v$.model.tacticalTaskSumPlan.$error &&
                    !v$.model.totalSumPlan.$error
                  "
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramBudgetInfo')"
                      :bottom="$t('addressProgramBudgetDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout :gap="20">
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceInputNumber
                          ref="ratePerHourPlan-ProSpaceInputNumber"
                          v-model="model.ratePerHourPlan"
                          disabled
                          :integeronly="false"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :max="100000"
                          :label="$t('addressProgramOrderRatePerHour')"
                          :placeholder="
                            adjustmentFields.includes('ratePerHourPlan')
                              ? $t('addressProgramOrderAdjustmentNewValue')
                              : $t('addressProgramOrderRatePerHour')
                          "
                          :invalid="v$.model.ratePerHourPlan.$error"
                          :invalid-messages="v$.model.ratePerHourPlan.$errors"
                          likeText
                          @blur="v$.model.ratePerHourPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="visitSumPlan-ProSpaceInputNumber"
                          v-model="model.visitSumPlan"
                          disabled
                          :defaultFormat="false"
                          :formatter="formatDigit"
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderVisitSum')"
                          :placeholder="$t('addressProgramOrderVisitSum')"
                          :invalid="v$.model.visitSumPlan.$error"
                          :invalid-messages="v$.model.visitSumPlan.$errors"
                          likeText
                          @blur="v$.model.visitSumPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="osaSumPlan-ProSpaceInputNumber"
                          v-model="model.osaSumPlan"
                          disabled
                          :defaultFormat="false"
                          :formatter="formatDigit"
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderBudgetOSAPlan')"
                          :placeholder="$t('addressProgramOrderBudgetOSAPlan')"
                          :invalid="v$.model.osaSumPlan.$error"
                          :invalid-messages="v$.model.osaSumPlan.$errors"
                          likeText
                          @blur="v$.model.osaSumPlan.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout
                        justify-content="flex-start"
                        align-items="flex-start"
                        :gap="20"
                      >
                        <ProSpaceInputNumber
                          ref="pssSumPlan-ProSpaceInputNumber"
                          v-model="model.pssSumPlan"
                          disabled
                          :defaultFormat="false"
                          :formatter="formatDigit"
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderPssSum')"
                          :placeholder="$t('addressProgramOrderPssSum')"
                          :invalid="v$.model.pssSumPlan.$error"
                          :invalid-messages="v$.model.pssSumPlan.$errors"
                          likeText
                          @blur="v$.model.pssSumPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="tacticalTaskSumPlan-ProSpaceInputNumber"
                          v-model="model.tacticalTaskSumPlan"
                          disabled
                          :defaultFormat="false"
                          :formatter="formatDigit"
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderTacticalTaskSum')"
                          :placeholder="
                            $t('addressProgramOrderTacticalTaskSum')
                          "
                          :invalid="v$.model.tacticalTaskSumPlan.$error"
                          :invalid-messages="
                            v$.model.tacticalTaskSumPlan.$errors
                          "
                          likeText
                          @blur="v$.model.tacticalTaskSumPlan.$touch"
                        />
                        <ProSpaceInputNumber
                          ref="totalSumPlan-ProSpaceInputNumber"
                          v-model="model.totalSumPlan"
                          disabled
                          :defaultFormat="false"
                          :formatter="formatDigit"
                          :integeronly="false"
                          :maxFractionDigits="2"
                          :label="$t('addressProgramOrderTotalSum')"
                          :placeholder="$t('addressProgramOrderTotalSum')"
                          :invalid="v$.model.totalSumPlan.$error"
                          :invalid-messages="v$.model.totalSumPlan.$errors"
                          likeText
                          @blur="v$.model.totalSumPlan.$touch"
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>

                  <template
                    v-if="
                      v$.model.ratePerHourPlan.$error ||
                      v$.model.visitSumPlan.$error ||
                      v$.model.osaSumPlan.$error ||
                      v$.model.pssSumPlan.$error ||
                      v$.model.tacticalTaskSumPlan.$error ||
                      v$.model.totalSumPlan.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
                <ProSpaceGeoLayout
                  v-if="adjustmentMode"
                  class="geo-row"
                  isHideBottom
                  isHideTop
                  :isHideRight="!v$.model.comment.$error"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('addressProgramCommentInfo')"
                      :bottom="$t('addressProgramCommentDescription')"
                      :gap="10"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceHLayout
                      justify-content="flex-start"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceInputText
                        ref="comments-ProSpaceInputText"
                        class="addressprogramorder__input-textarea"
                        v-model="model.comment"
                        disabled
                        isTextarea
                        :label="$t('addressProgramOrderComment')"
                        :placeholder="$t('addressProgramOrderComment')"
                        :invalid="v$.model.comment.$error"
                        :invalid-messages="v$.model.comment.$errors"
                        @blur="v$.model.comment.$touch"
                      />
                    </ProSpaceHLayout>
                  </template>

                  <template v-if="v$.model.comment.$error" v-slot:right>
                    <ProSpaceVLayout justify-content="center">
                      <ProSpaceIcon icon="warning" colored />
                    </ProSpaceVLayout>
                  </template>
                </ProSpaceGeoLayout>
              </ProSpaceVLayout>
            </template>
            <template v-slot:tab-2>
              <AdjustmentOutletsGrid
                :service="addressProgramOrderService"
                :defaultFilter="adjustmentOutletFilterObject || adjustmentOutletFilter"
                get-method="grid"
                :check-access="checkAccess"
              />
            </template>
          </ProSpaceTabs>
        </template>
      </ProSpaceGeoLayout>
    </template>
  </ProSpaceGeoLayout>
  <ProSpaceFlashMessage
    v-model="showBlockAdjustmentsModal"
    :cancelTxt="$t('closeTxt')"
    :title="$t('adjustmentsAreBlocked')"
    icon="flash-warning"
    @cancel="showBlockAdjustmentsModal = false"
  >
    {{ $t('adjustmentAreBlockedTextInfo') }}
  </ProSpaceFlashMessage>
</template>
<script>
import {
  ProSpaceTopPanel,
  ProSpaceInputText,
  ProSpaceAction,
  ProSpaceRadioButtonSecondary,
  ProSpaceGeoLayout,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpaceTextBlock,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceSearchfield,
  ProSpaceFile,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceMultiSelect,
  ProSpaceCustomFilterPanel,
  ProSpaceIcon,
  ProSpaceInputSwitch,
  ProSpaceLabel,
  ProSpaceTag,
  ProSpaceFlashMessage,
  ProSpaceDropdown,
} from "@prospace/prospace-components-library";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";
import { AddressProgramOrderService } from "../../services/AddressProgramOrderService.js";
import { RSMService } from "../../services/RSMService.js";
import { TDMService } from "../../services/TDMService.js";
import { KAEService } from "../../services/KAEService.js";
import { AgencyService } from "../../services/AgencyService.js";
import { NetworkService } from "../../services/NetworkService.js";
import { ExternalFormatService } from "../../services/ExternalFormatService.js";
import { OutletTypeService } from "../../services/OutletTypeService.js";
import { ChannelService } from "../../services/ChannelService.js";
import { ClusterService } from "../../services/ClusterService.js";
import { NARKAService } from "../../services/NARKAService.js";
import { SIPChannelService } from "../../services/SIPChannelService.js";
import { KASService } from "../../services/KASService.js";
import { MerchandiserService } from "../../services/MerchandiserService.js";
import { RouteCodeService } from "../../services/RouteCodeService.js";
import { AdjustmentService } from "../../services/AdjustmentService.js";
import { mapGetters } from "vuex";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import _ from "lodash";
import { helpers, minValue, createI18nMessage } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import AdjustmentOutletsGrid from "../Adjustments/components/AdjustmentOutletsGrid.vue";
export default {
  mixins: [accessMixin],
  props: ['id', 'adjustmentSettings', 'groupingState'],
  components: {
    AdjustmentOutletsGrid,
    ProSpaceTopPanel,
    ProSpaceGeoLayout,
    ProSpaceInputText,
    ProSpaceAction,
    ProSpaceRadioButtonSecondary,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpaceTextBlock,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceSearchfield,
    ProSpaceFile,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceMultiSelect,
    ProSpaceCustomFilterPanel,
    ProSpaceIcon,
    ProSpaceInputSwitch,
    ProSpaceLabel,
    ProSpaceTag,
    ProSpaceFlashMessage,
    ProSpaceDropdown
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    let defaultSearchFieldColumns = [
      { field: "code", header: this.$t("code") },
    ];

    let networkColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("networkValue") },
    ];
    let clusterColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("clusterValue") },
    ];
    let rSMColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("rSMValue") },
    ];
    let tDMColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("tDMValue") },
    ];
    let kAEColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("kAEValue") },
    ];
    let externalFormatColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("externalFormatValue") },
    ];
    let outletTypeColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("outletTypeValue") },
    ];
    let channelColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("channelValue") },
    ];
    let nARKAColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("nARKAValue") },
    ];
    let sIPChannelColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("sIPChannelValue") },
    ];
    let territoryClusterColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("territoryClusterValue") },
    ];
    let agencyColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("agencyValue") },
    ];
    let kASColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("kASValue") },
    ];
    let merchandiserColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("merchandiserValue") },
    ];
    let routeCodeColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("routeCodeValue") },
    ];

    return {
      // Adjustment
      adjustmentMode: false,
      adjustmentOutletFilter: null,
      adjustmentOutletFilterObject: null,
      addressProgramOrdersToAdjust: [],

      // Tabs
      modelTab: {
        name: this.$t("parameters"),
        systemName: "parameters",
        isActive: true,
      },

      // Common
      layoutName: "",
      model: null,
      compareModel: null,
      loading: false,
      disabled: false,

      // Service
      addressProgramOrderService: new AddressProgramOrderService(),
      rSMService: new RSMService(),
      tDMService: new TDMService(),
      kAEService: new KAEService(),
      agencyService: new AgencyService(),
      networkService: new NetworkService(),
      externalFormatService: new ExternalFormatService(),
      outletTypeService: new OutletTypeService(),
      channelService: new ChannelService(),
      clusterService: new ClusterService(),
      nARKAService: new NARKAService(),
      sIPChannelService: new SIPChannelService(),
      kASService: new KASService(),
      merchandiserService: new MerchandiserService(),
      routeCodeService: new RouteCodeService(),
      adjustmentService: new AdjustmentService(),

      getMethod: "get",
      masterId: null,

      // SearchField
      networkColumns: networkColumns,
      clusterColumns: clusterColumns,
      rSMColumns: rSMColumns,
      tDMColumns: tDMColumns,
      kAEColumns: kAEColumns,
      externalFormatColumns: externalFormatColumns,
      outletTypeColumns: outletTypeColumns,
      channelColumns: channelColumns,
      nARKAColumns: nARKAColumns,
      sIPChannelColumns: sIPChannelColumns,
      territoryClusterColumns: territoryClusterColumns,
      agencyColumns: agencyColumns,
      kASColumns: kASColumns,
      merchandiserColumns: merchandiserColumns,
      routeCodeColumns: routeCodeColumns,

      prefixTop: "",
      prefixBottom: "",

      groupCounter: null,
      agencyId: null,
      showBlockAdjustmentsModal: false,
    };
  },
  validations() {
    const withI18nMessage = createI18nMessage({ t: this.$t });
    const localMinValue = withI18nMessage(minValue(this.model?.coverage? 1 : 0), { withArguments: true });

    return {
      model: {
        marsPeriod: {},
        outletId: {},
        area: {},
        networkCode: {},
        externalCode: {},
        city: {},
        address: {},
        coverage: {},
        coverageComments: {},
        comment: {},
        rsmId: {},
        tdmId: {},
        kaeId: {},
        agencyId: {},
        networkId: {},
        externalFormatId: {},
        outletTypeId: {},
        channelId: {},
        clusterId: {},
        narkaId: {},
        sipChannelId: {},
        kasValue: {},
        merchandiserValue: {},
        routeCodeValue: {},
        tariffZone: {},
        territoryCluster: {},
        skyline: {},
        ratePerHourPlan: {},
        timingPerVisitPlan: {},
        fteMerchPlan: {},
        frequencyPlan: !this.isMultiAdjustmentMode ? {
          localMinValue
        } : {},
        outletCount: {},
        osaPlan: {},
        deltaISAOSAPlan: {},
        pssPlan: {},
        tacticalTaskPlan: {},
        visitSumPlan: {},
        osaSumPlan: {},
        pssSumPlan: {},
        tacticalTaskSumPlan: {},
        totalSumPlan: {},
      },
    };
  },
  beforeRouteLeave() {
    if(this.$route.query.settingsCode)
      localStorage.removeItem(this.$route.query.settingsCode);
  },
  created() {
    let me = this;

    me.masterId = me.$route.params.id;
    const settingsCode = this.$route.query.settingsCode;

    if (settingsCode && atob(settingsCode).includes(this.userinfo.id)) {
      let stringSettings = localStorage.getItem(settingsCode);
      let settings = stringSettings ? JSON.parse(stringSettings) : null;
      if (settings) {
        if (settings.adjustmentSettings) {
          me.adjustmentMode = true;
          me.addressProgramOrdersToAdjust = settings.adjustmentSettings.records;
          me.adjustmentOutletFilter = settings.adjustmentSettings.filter;
          me.adjustmentOutletFilterObject = settings.adjustmentSettings.filterObject;
          me.groupCounter = settings.adjustmentSettings.groupCounter;
        }
        if (settings.groupingState) {
            me.groupingState = settings.groupingState
        }
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDigit,
    async getData() {
      let result = {};
      this.disabled = false;

      if (this.isMultiAdjustmentMode) {
        result["data"] = {
          code: null,
          address: null,
          territoryCluster: 0,
          externalCode: 0,
          tariffZone: 0,
          skyline: 0,
          frequencyPlan: 0,
          timingPerVisitPlan: 0,
          fteMerchPlan: 0,
          osaPlan: 0,
          deltaISAOSAPlan: 0,
          pssPlan: 0,
          tacticalTaskPlan: 0,
          ratePerHourPlan: 0,
          visitSumPlan: 0,
          osaSumPlan: 0,
          pssSumPlan: 0,
          tacticalTaskSumPlan: 0,
          totalSumPlan: 0,
          coverage: null
        };

        if (this.$route.query.adjustmentSettings) {
          let settings = JSON.parse(this.$route.query.adjustmentSettings);
          result["data"].agencyId = settings.agencyId;
          result["data"].agencyValue = settings.agencyValue;
        } else if (this.agencyId) {
          result["data"].agencyId = this.agencyId;
          result["data"].agencyValue = this.agencyValue;
        }

        this.adjustmentFields.forEach((key) => {
          result["data"][key] = null;
        });

        this.layoutName = `${this.$t("adjustmentGroupTT")} | ${this.$t("adjustmentRequest")}`;
      } else {
        if (this.masterId === undefined) return;

        result = await this.addressProgramOrderService[this.getMethod](this.masterId);

        this.layoutName = result.data.networkValue;
        if (this.adjustmentMode)
          this.layoutName += ` | ${this.$t("adjustmentRequest")}`;
      }

      this.model = result.data;

      this.model.osaPlan = this.model.osaPlan ? this.model.osaPlan * 100 : 0;
      this.model.deltaISAOSAPlan = this.model.deltaISAOSAPlan ? this.model.deltaISAOSAPlan * 100 : 0;
      this.model.pssPlan = this.model.pssPlan ? this.model.pssPlan * 100 : 0;

      this.compareModel = _.cloneDeep(this.model);

      this.$nextTick(() => {
        this.disabled = true;
      })
    },
    buildAdjustmentModel() {
      let me = this;

      let adjustmentModel = {
        addressProgramOrders: me.isMultiAdjustmentMode? me.addressProgramOrdersToAdjust : [ me.model ]
      };
      let editedFields = [];

      let getLabelCode = function(key) {
        let labelCode = "addressProgramOrder" + key[0].toUpperCase() + key.slice(1);
        if(labelCode.includes("Plan"))
          labelCode = labelCode.slice(0, -4);

        if(labelCode.includes("Id"))
          labelCode = labelCode.slice(0, -2) + "Value";

        return labelCode;
      }

      const prevLocale = me.$i18n.locale;
      me.$i18n.locale = "ru";

      me.adjustmentFields.forEach((key) => {
        let mVal = me.model[key] === undefined ? null : me.model[key];
        let cVal = me.compareModel[key] === undefined ? null : me.compareModel[key];
        if (mVal !== cVal) {
          let displayValue = null;
          let oldDisplayValue = null;
          if(key === "osaPlan" || key === "deltaISAOSAPlan" || key === "pssPlan") {
            displayValue = me.model[key].toFixed(2);
            oldDisplayValue = me.compareModel[key];
            me.model[key] /= 100;
          }
          else if(key.includes("Id")){
            let keyValue = key.slice(0, -2) + "Value";
            displayValue = me.model[keyValue];
            oldDisplayValue = me.compareModel[keyValue];
          }

          editedFields.push({
            key: key,
            name: me.$t(getLabelCode(key)),
            oldDisplayValue: oldDisplayValue,
            displayValue: displayValue,
            oldValue: me.compareModel[key],
            newValue: me.model[key],
            agreementStatus: null,
            approveStatus: null,
          });
        }
      });
      me.$i18n.locale = prevLocale;

      let filter = me.isMultiAdjustmentMode
        ? me.adjustmentOutletFilter
        : null;

      adjustmentModel["adjustmentComment"] = me.model.comment;
      adjustmentModel["securityRoleSystemName"] = JSON.parse(localStorage.getItem("userRole")).systemName;
      adjustmentModel["addressProgramOrderFilter"] = filter;
      adjustmentModel["editedFields"] = editedFields
        .map((x) => x.name)
        .join(", ");
      adjustmentModel["editedFieldsConfig"] = JSON.stringify(editedFields);

      return adjustmentModel;
    },
    submitFilter(nameRef = "grid") {
      if (!this.$refs[nameRef]) return;
      this.$refs[nameRef].getRecords(true);
    },
    backHandler() {
      if (this.groupingState) {
        this.$router.push({
          name: 'addressprogramorders',
          params: {
            groupingState: JSON.stringify(this.groupingState)
          }
        })
        return
      }
      this.$router.go(-1);
    },
    changeModelValue(option, refName) {
      this.model[option] =
        this.$refs[refName + "-ProSpaceSearchfield"].modelInput;
    },
  },
  computed: {
    ...mapGetters({
      access: "securityRoleAccess/access",
      userinfo: "userinfoStore/getUserinfo",
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod",
    }),
    coverageOptions() {
      const options = [
        {label: this.$t('yes'), value: true},
        {label: this.$t('no'), value: false},
      ]
      if (this.isMultiAdjustmentMode) {
        options.push({
          label: this.$t('noSeletValue'), value: null
        })
      }
      return options
    },
    adjustmentFields() {
      let fields = [];
      if (this.adjustmentMode)
        this.refsForCheckInMixin.forEach((ref) => {
          if (
            !ref.includes("action-") &&
            !ref.includes("comments-") &&
            this.checkAccess(ref, null, true)
          )
            fields.push(ref.split("-")[0]);
        });

      return fields;
    },
    refsForCheckInMixin() {
      let refs = [];
      refs.push(
        "networkId-ProSpaceSearchfield",
        "address-ProSpaceInputText",
        "coverage-ProSpaceInputSwitch",
        "area-ProSpaceInputText",
        "city-ProSpaceInputText",
        "clusterId-ProSpaceSearchfield",
        "rsmId-ProSpaceSearchfield",
        "tdmId-ProSpaceSearchfield",
        "kaeId-ProSpaceSearchfield",
        "externalFormatId-ProSpaceSearchfield",
        "outletTypeId-ProSpaceSearchfield",
        "channelId-ProSpaceSearchfield",
        "narkaId-ProSpaceSearchfield",
        "sipChannelId-ProSpaceSearchfield",
        "territoryCluster-ProSpaceInputNumber",
        "externalCode-ProSpaceInputText",
        "tariffZone-ProSpaceInputNumber",
        "skyline-ProSpaceInputNumber",
        "kasValue-ProSpaceSearchfield",
        "merchandiserValue-ProSpaceSearchfield",
        "routeCodeValue-ProSpaceSearchfield",
        "frequencyPlan-ProSpaceInputNumber",
        "timingPerVisitPlan-ProSpaceInputNumber",
        "fteMerchPlan-ProSpaceInputNumber",
        "osaPlan-ProSpaceInputNumber",
        "deltaISAOSAPlan-ProSpaceInputNumber",
        "pssPlan-ProSpaceInputNumber",
        "tacticalTaskPlan-ProSpaceInputNumber",
        "ratePerHourPlan-ProSpaceInputNumber",
        "visitSumPlan-ProSpaceInputNumber",
        "osaSumPlan-ProSpaceInputNumber",
        "pssSumPlan-ProSpaceInputNumber",
        "tacticalTaskSumPlan-ProSpaceInputNumber",
        "totalSumPlan-ProSpaceInputNumber"
      );

      if (!this.adjustmentMode) {
        refs.push(
          "agencyId-ProSpaceSearchfield",
        );
      }
      else refs.push("comments-ProSpaceInputText");

      return refs;
    },
    isMultiAdjustmentMode() {
      return (this.adjustmentMode && this.groupCounter && this.groupCounter > 1) || this.$route.name === 'adjustmentmultiplecreate';
    },
    isCorrectionChanges() {
      return Object.keys(this.model).some(key => {
          let mVal = this.model[key];
          let cVal = this.compareModel[key];
          return key == "comment"? false : mVal != cVal;
      });
    },
    overviewTabs() {
      return [
        {
          name: this.$t("parameters"),
          systemName: "parameters",
          isActive: this.modelTab.systemName === "parameters",
        },
        {
          name: this.$t("outlets"),
          systemName: "outlets",
          isActive: this.modelTab.systemName === "outlets",
          isHidden: !this.isMultiAdjustmentMode,
          counter: this.groupCounter
        },
      ];
    },
    headerTag() {
      return {
        prefix: this.$t('addressProgramOrderOutletId'),
        text: this.model.outletId,
        type: 'gray-light'
      }
    },
    searchFieldGridStyles() {
      return {
        height: "50vh",
        width: "30vw",
      }
    }
  },
};
</script>
<style lang="scss">
.addressprogramorder {
  &__rows {
    & > .geo-row {
      grid-template-columns: 220px minmax(306px, 958px) !important;
      grid-template-areas: "left center"; // set "left center right" when will need show right-col
      width: auto;
    }
  }
  .prospace-input-layout {
    max-width: 306px;
  }
  &__input-textarea {
    max-width: 633px !important;
  }

  .prospace-text-block__bottom {
    color: var(--prospace-ui-icon-gray);
  }
}
</style>
